import { render, staticRenderFns } from "./component-special.vue?vue&type=template&id=5b8a91e4&scoped=true&"
import script from "./component-special.vue?vue&type=script&lang=js&"
export * from "./component-special.vue?vue&type=script&lang=js&"
import style0 from "./component-special.vue?vue&type=style&index=0&id=5b8a91e4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8a91e4",
  null
  
)

export default component.exports